// Components
import registerSketch from '../../../../common/drawings/sketches/index';
import presentationalComponent from './Sketch';
import containerComponent from './SketchContainer';
import modalComponent from './modal/LoadableSketchModal';

// Constants
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../../workspace/toolbar/config/toolbarToolConfig';
import { tagsFeaturePredicate } from '../../tags/tagsUtils';

export default () =>
    registerSketch({
        presentationalComponent,
        containerComponent,
        modalComponent,
        tools: {
            selected: [
                { ...TOOLBAR_TOOLS.COLOR, name: 'Background', localeKey: 'tools.selected.background' },
                TOOLBAR_TOOLS.EDIT_DRAWING,
                TOOLBAR_TOOLS.CAPTION,
                TOOLBAR_TOOLS.REACTION,

                { ...TOOLBAR_TOOLS.TAGS, availabilityPredicate: tagsFeaturePredicate },
                TOOLBAR_TOOLS.COMMENT,
                ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
            ],
            editing_CAPTION: TOOL_SETS.TEXT_EDITING_CAPTION,
        },
    });
